
export default {
  props: ['disabled', 'size'],
  data: function data() {
    return {
      visible: false,
      qualityMenu: [{
        label: this.$t('commonNavbar.lowQuality'),
        value: '3,3,3'
      }, {
        label: this.$t('commonNavbar.middleQuality'),
        value: '2,2,2'
      }, {
        label: this.$t('commonNavbar.highQuality'),
        value: '1,1,1'
      }, {
        label: '原始',
        value: '0,0,0'
      }]
    };
  },

  methods: {
    handleLeave: function handleLeave() {
      this.visible = false;
    },
    handleClick: function handleClick(item) {
      this.$emit('download', item.value);
      this.visible = false;
    }
  }
};